<template>
  <!-- 案例库 -->
  <div class="case-area">
    <div class="area-chosebox">
      <div class="current-city">
        当前区域：全国<span>{{ selProvince ? ' / ' + selProvince : '' }}</span>
      </div>
      <div v-for="(item, index) in allCity" :key="'city' + index">
        <div class="city-item">
          <div class="letter">{{ item.letter }}</div>
          <ul class="r-city">
            <li
              class="scity"
              v-for="(secondItem, secondIndex) in item.itemCity"
              :key="secondIndex"
              :class="{ selected: selProvince === secondItem.label }"
              @click="handleProvinceChange(secondItem)"
            >
              {{ secondItem.label }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="quick-search">
      <span class="name">快速搜索：</span>
      <a-select
        :default-value="searchTypeList[0].value"
        style="width: 95px"
        v-model="searchType"
      >
        <a-select-option
          v-for="(d, index) in searchTypeList"
          :value="d.value"
          :key="index"
        >
          {{ d.name }}
        </a-select-option>
      </a-select>
      <a-input-search
        placeholder="请输入"
        enter-button="搜索"
        style="width: 800px"
        size="large"
        @search="handleKeywordSearch"
      />
      <!-- <a-button>高级搜索</a-button> -->
    </div>
    <div class="chose-search">
      <div class="left">
        <span class="name">选择排序：</span>
        <a-select
          default-value="上线时间"
          style="width: 95px"
          @change="handleOrder"
        >
          <a-select-option value="create_time"> 上线时间 </a-select-option>
          <a-select-option value="hit_count"> 访问量 </a-select-option>
        </a-select>
        <!--        <span class="tag">访问量</span>-->
      </div>
      <div class="search-result">
        <span>共找到 {{ pagination.total }} 条结果</span> <span>每页显示</span>
        <b
          :class="{ cur: num === index }"
          v-for="(item, index) in pageNum"
          :key="index"
          @click="pageClick(item, index)"
        >
          {{ item }}
        </b>
      </div>
    </div>
    <div class="table-box">
      <a-table
        :columns="columns"
        :data-source="tableList"
        bordered
        :customRow="gotoDetail"
        rowKey="pkid"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <!-- <span slot="case_type" slot-scope="text">{{text | caseType(categoryList)}}</span> -->
      </a-table>
    </div>
  </div>
</template>
<script>
import { getCaseList } from '@/api/case';
import citydata from '@/assets/city';
import {notEmpty} from "../../utils/util";

const columns = [
  {
    title: '案例名称',
    dataIndex: 'case_name',
    key: 'case_name',
  },
  {
    title: '案例编号',
    dataIndex: 'serial_number',
    key: 'serial_number',
  },
  {
    title: '案例类别',
    dataIndex: 'case_type',
    key: 'case_type',
    scopedSlots: { customRender: 'case_type' },
  },
];
const tableList = [];
export default {
  name: 'CaseBase',
  data() {
    return {
      tableList,
      columns,
      num: 0,
      sunm: 0,
      pageNum: [10, 20, 30],
      pagination: {
        total: 0,
        pageSize: 10,
        current: 1,
      },
      queryParam: {
        case_region: null,
        case_name: null,
        case_content: null,
        case_info: null,
        handle_process: null,
        handle_result: null,
        maintain_platform: null,
        page: 1,
        rows: 10,
        sidx: null,
        sord: null,
      },
      allCity: [
        {
          fIndex: 0,
          letter: 'A-G',
          itemCity: citydata.filter(
            (v) => 'abcdefg'.split('').indexOf(v.letter) >= 0
          ),
        },
        {
          fIndex: 1,
          letter: 'H-J',
          itemCity: citydata.filter(
            (v) => 'hij'.split('').indexOf(v.letter) >= 0
          ),
        },
        {
          fIndex: 2,
          letter: 'L-S',
          itemCity: citydata.filter(
            (v) => 'lmnopqrs'.split('').indexOf(v.letter) >= 0
          ),
        },
        {
          fIndex: 3,
          letter: 'T-Z',
          itemCity: citydata.filter(
            (v) => 'tuvwxyz'.split('').indexOf(v.letter) >= 0
          ),
        },
        // {
        //   fIndex: 4,
        //   letter: '其他',
        //   itemCity: citydata.filter((v) => v.letter === '其他'),
        // },
      ],
      citySelector: {
        province: '',
        city: '',
      },
      selProvince: '',
      searchTypeList: [
        { name: '案例名称', value: 'case_name' },
        { name: '案例简介', value: 'case_info' },
        { name: '具体内容', value: 'case_content' },
        { name: '处理过程', value: 'handle_process' },
        { name: '处理结果', value: 'handle_result' },
        { name: '维权平台', value: 'maintain_platform' },
      ],
      searchType: 'case_name',
    };
  },
  mounted() {
    this.getCaseList();
  },
  computed: {},

  methods: {
    async getCaseList() {
      let category = this.$store.state.category;
      await getCaseList(notEmpty(this.queryParam)).then((res) => {
        let tmp = res.items;

        tmp.forEach((item) => {
          item.case_type = category.CaseType[item.case_type];
        });
        this.tableList = tmp;
        if (this.tableList) {
          this.pagination.total = res.totalcount;
        }

        // this.pagination.pageSize = res.pagesize;
      });
    },
    handleTableChange(pagination) {
      // console.log(pagination)
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.queryParam.page = pagination.current;
      // this.queryParam.rows = pagination.pageSize;
      this.getCaseList();
    },
    handleProvinceChange(value) {
      if (this.selProvince === value.label) {
        this.selProvince = '';
        this.queryParam.case_region = null;
      } else {
        this.selProvince = value.label;
        this.queryParam.case_region = value.label;
      }
      this.getCaseList();
    },
    handleKeywordSearch(value) {
      this.searchTypeList.forEach((v) => {
        this.queryParam[v.value] = null;
      });
      this.queryParam[this.searchType] = value;
      this.getCaseList();
    },
    handleOrder(value) {
      this.queryParam.sidx = value;
      this.queryParam.sord = 'desc';
      this.getCaseList();
    },
    pageClick(value, index) {
      this.num = index;
      this.queryParam.rows = value;
      this.pagination.pageSize = value;
      this.getCaseList();
    },
    gotoDetail(record, index) {
      return {
        on: {
          click: () => {
            let routeUrl = this.$router.resolve({
              name: 'CaseView',
              query: { id: record.pkid },
            });
            window.open(routeUrl.href, '_blank');
          }
        },
        style:{
          "cursor":"pointer"
        }
      };
    },
  },
};
</script>
<style scoped>
.current-city {
  height: 40px;
  background: #a0adba;
  color: #fafbfc;
  line-height: 40px;
  padding: 0 20px;
  font-size: 15px;
}

.area-chosebox {
  background: #fafbfc;
}

.area-chosebox .city-item {
  display: flex;
  align-items: center;
  height: 32px;
  line-height: 32px;
  border-bottom: 1px solid #d3d9df;
}

.area-chosebox .city-item .letter {
  width: 84px;
  text-align: center;
  color: #2b86ef;
}

.area-chosebox .city-item .r-city {
  flex: 1;
  list-style: none;
  display: flex;
  margin: 0;
}

.area-chosebox .city-item .scity {
  width: 114px;
  text-align: center;
  justify-content: center;
  cursor: pointer;
}

.area-chosebox .city-item .scity.selected {
  color: #2b86ef;
}

.area-chosebox .sub-city {
  display: flex;
  background: #dfe3e9;
  flex-wrap: wrap;
}

.area-chosebox .sub-city a {
  width: 145px;
  text-align: center;
  color: #666;
  height: 32px;
  line-height: 32px;
  border-bottom: 1px solid #d3d9df;
}

.area-chosebox .sub-city a.selected {
  color: #2b86ef;
}

.case-area {
  padding: 6px 12px;
}

.quick-search {
  display: flex;
  height: 90px;
  align-items: center;
  background: url('~@/assets/images/search-bg.jpg') no-repeat;
  background-size: 100% 100%;
  padding: 0 20px;
}

.quick-search .ant-input-search {
  margin-left: 12px;
}

.quick-search .ant-btn {
  width: 115px;
  height: 40px;
  border: 1px solid #2b86ef;
  color: #2b86ef;
  border-radius: 2px;
  margin-left: 12px;
  font-size: 16px;
}

.quick-search .name {
  font-size: 17px;
  font-weight: bold;
  color: #666;
  margin-right: 10px;
}

.quick-search .ant-select {
  height: 40px;
}

.quick-search /deep/ .ant-select-selection--single {
  height: 40px;
}

.quick-search /deep/ .ant-select-selection__rendered {
  line-height: 38px;
}

.chose-search {
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: space-between;
  background: #e4eaf2;
  padding: 0 20px;
  margin: 10px 0 8px 0;
}

.chose-search .name {
  font-size: 17px;
  font-weight: bold;
  color: #666;
  margin-right: 10px;
}

.chose-search .tag {
  width: 56px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  display: inline-block;
  border: 1px solid #d9d9d9;
  background: #fff;
  margin-left: 12px;
}

.chose-search b {
  font-weight: normal;
  display: inline-block;
  width: 32px;
  text-align: center;
}

.search-result {
  color: #767677;
}
.chose-search b {
  cursor: pointer;
}
.chose-search b.cur {
  color: #2b86ef;
  cursor: pointer;
}
</style>
